export type CarouselHeightsSizes = 'small' | 'medium' | 'large' 

export const SLIDE_SIZES: Record<CarouselHeightsSizes, {sm: string, md: string, lg: string}> = {
  large: { sm: '100%', md: '80%', lg: '80%' },
  medium: { sm: '100%', md: '50%', lg: '33.3333%' },
  small: { sm: '50%', md: '33.3333%', lg: '16.6667%' }
}

export const CAROUSEL_HEIGHTS: Record<CarouselHeightsSizes, {height: number, controlHeight: number}> = {
  large: { height: 370, controlHeight: 169 },
  medium: { height: 500, controlHeight: 259 },
  small: { height: 120, controlHeight: 34 }
}